module.exports = __webpack_public_path__ + "static/f2e1ba694d9b08da9a8d68952621fbb0.webp";